'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AboutWindow = undefined;

var _isObject = require('d2-utilizr/lib/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AboutWindow = exports.AboutWindow = undefined;

exports.AboutWindow = AboutWindow = function AboutWindow(c) {
    var appManager = c.appManager,
        uiManager = c.uiManager,
        instanceManager = c.instanceManager,
        i18n = c.i18nManager.get(),
        apiPath = appManager.getApiPath();

    return Ext.create('Ext.window.Window', {
        title: i18n.about,
        bodyStyle: 'background:#fff; padding:6px',
        modal: true,
        resizable: false,
        destroyOnBlur: true,
        getData: function getData() {
            var t = this;

            Ext.Ajax.request({
                url: encodeURI(apiPath + '/system/info.json'),
                success: function success(r) {
                    var info = Ext.decode(r.responseText),
                        divStyle = 'padding:3px',
                        html = '<div class="user-select">';

                    if ((0, _isObject2.default)(info)) {
                        html += '<div style="' + divStyle + '"><b>' + i18n.time_since_last_data_update + ': </b>' + info.intervalSinceLastAnalyticsTableSuccess + '</div>';
                        html += '<div style="' + divStyle + '"><b>' + i18n.version + ': </b>' + info.version + '</div>';
                        html += '<div style="' + divStyle + '"><b>' + i18n.revision + ': </b>' + info.revision + '</div>';
                        html += '<div style="' + divStyle + '"><b>' + i18n.username + ': </b>' + appManager.userAccount.username + '</div>';
                        html += '</div>';
                    } else {
                        html += 'No system info found';
                    }

                    t.update(html);
                },
                failure: function failure(r) {
                    t.update(r.status + '\n' + r.statusText + '\n' + r.responseText);
                },
                callback: function callback() {
                    t.show();

                    uiManager.enableRightClick();

                    var aboutButton = uiManager.get('aboutButton') || {};

                    if (aboutButton.rendered) {
                        uiManager.setAnchorPosition(t, aboutButton);

                        if (!t.hasDestroyOnBlurHandler) {
                            uiManager.addDestroyOnBlurHandler(t);
                        }
                    }
                }
            });
        },
        listeners: {
            hide: function hide() {
                uiManager.disableRightClick();
            },
            destroy: function destroy() {
                uiManager.disableRightClick();
            }
        }
    });
};
//# sourceMappingURL=AboutWindow.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ui/AboutWindow.js
 ** module id = 58
 ** module chunks = 0 1
 **/